module.exports = __webpack_public_path__ + "static/media/star-ball_10.c98df651.png";